import * as React from 'react'
import { Card, H4 } from '@blueprintjs/core'

import { EventCalendar } from '@ui'

interface EventCalendarCardProps {
  city: string | null
}

export default function EventCalendarCard({ city }: EventCalendarCardProps) {
  return (
    <Card style={{ height: '100%', width: '100%' }}>
      <H4>Calendar</H4>
      <EventCalendar city={city} />
    </Card>
  )
}
